import Api from '@/services/Api'

export default {
  getPromocodes (token) {
    return Api().get('promocodes/')
  },

  addPromocode (promocode) {
    return Api().post('promocodes/', promocode)
  },

  deletePromocode (id) {
    return Api().delete('promocode/' + id)
  },
  applyPromocode (promocode) {
    return Api().post('getDiscount/', promocode)
  },
  applyPromocode2 (promocode) {
    return Api().post('getDiscount2/', promocode)
  },
  checkOrderCode (promocode) {
    return Api().get('checkOrderCode/' + promocode)
  }
}



// WEBPACK FOOTER //
// ./src/services/PromocodeService.js